import moment from 'moment';
import { Box, Center, Checkbox, Column, Radio, Row, Typography } from '@tempmee/react';
import { Pressable } from '~/commonComponents';
import { IJob } from '~/domain/Jobs';
import history from '~/browserHistory';
import ChevronRight from '~/images/arrow_right.svg';
import { IUser } from '~/models';
import { ShiftListSelectionMode } from './enums';

interface IProps {
  candidate: IUser;
  isChecked: boolean;
  job: IJob;
  mode: ShiftListSelectionMode;
  handleToggleOption: (jobId?: string) => void;
}

export const ShiftItem = ({
  candidate,
  isChecked = false,
  job,
  mode,
  handleToggleOption,
}: IProps) => {
  const { multipleCounters } = job;
  const offerCounter = multipleCounters.find((counter) => counter.candidate.id === candidate?.id)!;

  const hasCounterHours =
    offerCounter?.begin !== offerCounter?.originalBegin ||
    offerCounter?.end !== offerCounter?.originalEnd;
  const hasCounterRates = offerCounter?.rate !== offerCounter?.originalRate;

  return (
    <Row className="shift-item" height={16}>
      {mode === ShiftListSelectionMode.Multiple ? (
        <Checkbox
          checked={isChecked}
          onChange={() => handleToggleOption(job.id)}
          style={{ width: '10%', height: '100%', justifyContent: 'center' }}
        />
      ) : (
        <Radio
          value={job.id}
          checked={isChecked}
          onChange={() => handleToggleOption(job.id)}
          style={{ width: '10%', height: '100%', justifyContent: 'center' }}
        />
      )}
      <Pressable
        style={{
          flex: 1,
        }}
        onPress={() => {
          history.push(`/dashboard/candidates/${offerCounter.candidate.id}/jobs/${job.id}`, {
            fromBulkConfirmation: true,
          });
        }}
      >
        <Row className="flex-1" height={16} align="center">
          <Box className="flex-1">
            <Typography as="span">{moment(job?.jobDatetime).format('ddd, MMM DD, YYYY')}</Typography>
          </Box>
          <Column className="flex-1">
            <Typography as="span" bold>{job?.professionName}</Typography>
            <Typography as="span">{job?.profession}</Typography>
          </Column>
          <Column className="flex-1">
            <Typography as="span" style={{ textDecoration: hasCounterHours ? 'line-through' : 'none' }}>
              {job.localStartTime} - {job.localEndTime}
            </Typography>
            {hasCounterHours && (
              <Typography as="span" bold>
                {offerCounter?.local_begin} - {offerCounter?.local_end}
              </Typography>
            )}
          </Column>
          <Column className="flex-1">
            <Typography as="span" style={{ textDecoration: hasCounterRates ? 'line-through' : 'none' }}>
              {`$${offerCounter?.originalRate?.toFixed(2)}`}
            </Typography>
            {hasCounterRates && <Typography as="span" bold>{`$${offerCounter?.rate?.toFixed(2)}`}</Typography>}
          </Column>
          <Box className="flex-1">
            <Typography as="span" bold>{`$${job?.total?.toFixed(2)}`}</Typography>
          </Box>
          <Center width="11.2%">
            <img src={ChevronRight} alt="arrow" style={{ width: 16, height: 16 }} />
          </Center>
        </Row>
      </Pressable>
    </Row>
  );
};
